import React from "react";
import { Layout } from "antd";
import "./Footer.scss";

const Footer = () => {
  const { Footer } = Layout;

  return (
    <Footer className="footer">
      <p>Movies PopCorn 2020</p>
    </Footer>
  );
};

export default Footer;
